import { render } from "./MedicareCoverage.vue?vue&type=template&id=32ce4e5f&scoped=true"
import script from "./MedicareCoverage.vue?vue&type=script&lang=js"
export * from "./MedicareCoverage.vue?vue&type=script&lang=js"

import "./MedicareCoverage.vue?vue&type=style&index=0&id=32ce4e5f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ce4e5f"]])

export default __exports__